import { Button, FormControl, TextField } from '@material-ui/core';
import styled from 'styled-components';

interface Iprops {
  identificationkeyerror?: boolean;
  ownershiptypeerror?: boolean;
  messageError?: boolean;
}

export const StyledButton = styled(Button)`
  background: linear-gradient(45deg, #135db4 30%, #1473e6 90%);
  padding: 7px 14px;
  border-radius: 24px !important;
  height: 40px;
  width: 120px;
  & .MuiButton-label {
    color: #fff;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #292828;

  .buttonGroup {
    .ajuda {
      border-radius: 24px !important;
      width: 120px;
      height: 40px;
      margin-right: 20px;
      border: 1px solid rgb(255 255 255);
      color: #fff;
    }
  }

  .header {
    border-bottom: 1px #707070 solid;
    padding-bottom: 20px;

    h1 {
      font-size: 2.8rem;
      color: ${props => props.theme.colors.primaryText};
      margin: 0 0 40px 0;
    }

    .login-information {
      & > * {
        margin: 0 20px 20px 0;
      }
    }

    .TextField-lgpd {
      width: 100%;
      max-width: 300px;

      & + .TextField-lgpd {
        margin-top: 0px;
      }
    }
  }

  .main-content-solicitar-ajuda-dpo {
    margin-top: 40px;
    margin-bottom: 40px;
    display: flex;
  }

  .contact-dpo-left {
    width: 100%;
    max-width: 300px;
    display: flex;
    flex-direction: column;
  }

  .contact-dpo-right {
    flex: 1;
    padding: 0 25px;
    position: relative;

    .closeButton {
      background: transparent;
      border: none;
      position: absolute;
      top: 102px;
      right: 44px;
      z-index: 100;

      SVG {
        color: #fff;
      }
    }

    .input-file-LGPD {
    }

    .input-file-LGPD {
      border: 1px solid;
      border-color: #fff;
      border-radius: 4px;
      background-color: #292828;
      min-height: 53.63px;

      .MuiDropzonePreviewList-removeButton {
        color: #fff;
      }

      .MuiDropzoneArea-textContainer {
        border: 1px dashed;
        border-color: #ffffff38;
        border-radius: 4px;
        border-spacing: 10px;
        height: 46px;
        margin: 3px;
        display: flex;
        align-items: center;
        align-content: center;

        .MuiTypography-root {
          color: #fff;
          margin: auto;
        }

        p {
          margin-bottom: 60px;
          padding: 0 15px;
        }

        svg {
          display: none;
        }
      }

      .MuiDropzonePreviewList-root {
        flex-direction: column;
        margin: 10px 0;
        width: 100%;

        .MuiDropzonePreviewList-imageContainer {
          width: 100%;
          max-width: 100%;
          padding: 5px 10px;

          &:hover {
            background: #22222208;
          }

          .MuiDropzonePreviewList-image {
            display: none;
          }

          .MuiTypography-body1 {
            text-align: left;
            width: 85%;
            margin: 15px 0;
            color: #fff;
            font-size: 1.4rem;
          }

          .MuiDropzonePreviewList-removeButton {
            opacity: 1;
            right: 7px;
            top: 12%;
            background: no-repeat;
            box-shadow: none;
          }
        }
      }
    }
  }

  .email-field {
    margin-top: 30px;
  }

  .TextField-lgpd {
    width: 100%;
    max-width: 300px;

    & + div {
      margin-top: 30px;
    }

    > label {
      color: ${props => props.theme.colors.primaryText};
      font-size: 1.4rem;
    }

    .MuiInputBase-root {
      font-size: 1.4rem;

      input {
        color: ${props => props.theme.colors.primaryText};
        font-size: 1.4rem;
      }
      fieldset {
        border-color: #929292;
      }
    }
  }

  .descricao-solicitacao {
  }
`;

export const ParagraphDPO = styled.p<Iprops>`
  color: ${props =>
    props.messageError ? '#c53030' : props.theme.colors.primaryText};
  font-size: 14px;
  margin: 7px 0 4px;
`;

export const MessageDPO = styled.textarea<Iprops>`
  border-radius: 4px;
  width: 100%;
  background: ${props => props.theme.colors.primaryBackground};
  color: ${props => props.theme.colors.primaryText};
  padding: 10px;
  height: 138px;

  border: 1px solid;
  border-color: ${props => (props.messageError ? '#c53030' : '#eaeaea')};
`;

export const StyledTextField = styled(TextField)<Iprops>`
  & + div {
    margin-top: 30px;
  }

  .MuiInputBase-root {
    font-size: 1.4rem;

    input {
      color: ${props => props.theme.colors.primaryText};
    }
  }

  label.focused {
    background-color: #1535ff !important;
    padding: 14.5px 14px;
  }

  .MuiFormLabel-root {
    font-size: 1.4rem;
    text-align: center;
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${props =>
      props.identificationkeyerror
        ? '#c53030 !important'
        : '#1535ff !important'};
  }

  .MuiInputLabel-outlined {
    color: ${props => (props.identificationkeyerror ? '#c53030' : ' #a2a3a5')};

    padding: 2px 10px;
    margin-left: -5px;
  }

  .MuiOutlinedInput-root {
    font-size: 14px;

    fieldset {
      border-color: ${props =>
        props.identificationkeyerror ? '#c53030' : '#eaeaea'};
    }

    &:hover fieldset {
      border-color: ${props =>
        props.identificationkeyerror ? '#c53030' : '#eaeaea'};
      border-color: ${props => !!props.disabled && '#bdbdbd'};
    }

    &.Mui-focused fieldset {
      color: red;
      border-color: ${props =>
        props.identificationkeyerror
          ? '#c53030 !important'
          : '#1535ff !important'};
    }
  }
`;

export const FormControlLGPD = styled(FormControl)<Iprops>`
  width: 100%;

  label {
    color: ${props =>
      props.ownershiptypeerror ? '#c53030 !important' : '#eaeaea !important'};
  }

  .MuiInputBase-root {
    color: ${props =>
      props.ownershiptypeerror ? '#c53030 !important' : '#eaeaea !important'};

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${props =>
        props.ownershiptypeerror ? '#c53030' : '#eaeaea'};
    }

    svg {
      top: 20px;
      color: ${props =>
        props.ownershiptypeerror ? '#c53030 !important' : '#eaeaea'};
    }
    font-size: 14px;

    fieldset {
      border-color: ${props =>
        props.ownershiptypeerror ? '#c53030 !important' : '#eaeaea'};

      &:hover fieldset {
        border-color: ${props =>
          props.ownershiptypeerror ? '#c53030' : '#eaeaea'};
      }

      legend {
        border-bottom: 0;
        width: auto !important;
      }
    }

    &.Mui-focused fieldset {
      color: red;
      border-color: ${props =>
        props.ownershiptypeerror ? '#c53030 !important' : '#1535ff !important'};
    }
  }

  label.focused {
    background-color: #1535ff !important;
    padding: 14.5px 14px;
  }

  .MuiFormLabel-root {
    font-size: 14px;
    text-align: center;
    padding: 2px 10px;
    margin-left: -5px;
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${props =>
      props.ownershiptypeerror ? '#c53030 !important' : '#1535ff !important'};
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${props =>
      props.ownershiptypeerror ? '#c53030 !important' : ' #a2a3a5 !important'};
  }

  .MuiInputLabel-outlined {
    color: ${props => (props.ownershiptypeerror ? '#c53030' : ' #a2a3a5')};
  }

  padding: 2px 10px;
  margin-left: -5px;

  .MuiSelect-select:not([multiple]) option,
  .MuiSelect-select:not([multiple]) optgroup {
    color: #222;
  }
`;
